import { z } from 'zod';
import { UserProfileSocialPlatformSchema } from '@/types/api/response/user';

/** Body for POST /user/follow. */
export const FollowUserPayloadSchema = z.object({
  user_id: z.string(),
});

export type FollowUserPayload = z.infer<typeof FollowUserPayloadSchema>;

/** Editable fields supported by PATCH /user/profile. */
export const UpdateUserProfilePayloadSchema = z.object({
  username: z.string().trim().min(1, 'profile-editor.validation.username-required'),
  bio: z.string().max(500, 'profile-editor.validation.bio-length'),
  is_private: z.boolean(),
  social_links: z.array(z.object({
    platform: UserProfileSocialPlatformSchema,
    url: z.string().trim().max(2048, 'profile-editor.validation.url-length')
      .url('profile-editor.validation.url-invalid')
      .refine(value => /^https?:\/\//i.test(value), 'profile-editor.validation.url-protocol'),
  })).max(10, 'profile-editor.validation.links-length'),
});

export type UpdateUserProfilePayload = z.infer<typeof UpdateUserProfilePayloadSchema>;
